import BaseService from "src/packages/BaseService";

export default class PlanService extends BaseService {
	static get className () {
		return "plan";
	}

	static async getPayMentLink (planData) {
		return await BaseService.getService().get(`purchase?planId=${planData.id}&coupon=${planData.coupon}&custom=${planData.custom}`);
	}
};
